module.exports = __webpack_public_path__ + "img/hk_product@2x.3740cd86.png";